<template>
    <nav :class="{ open }" @mouseover="onMouseOver" @mouseleave="open = false" @wheel.stop="wheel">
        <div class="menu-pane">
            <div class="menu-pane-content">
                <div class="burger">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" viewBox="0 0 40 30" @click="toggleOpen">
                        <rect width="40" height="3" rx="1" transform="translate(0 10)" fill="#333"/>
                        <rect width="40" height="3" rx="1" transform="translate(0 20)" fill="#333"/>
                        <rect width="40" height="3" rx="1" fill="#333"/>
                    </svg>
                    <img src="/static/img/ogt-logo.png" alt="" @click="navigate( 0, true )" />
                </div>
                <div class="space"></div>
                <ul>
                    <li v-for="(item) of navItems" :class="{ active: item === current, sub: item.sub }" @click="navigate( item.index )"><span>&nbsp;</span>{{ item.title }}</li>
                </ul>
                <div class="space"></div>
                <a class="download" href="/static/pdf/jaarverslag-2021.pdf?v2" download>
                    <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
                        <g>
                            <path stroke="#333" id="svg_2" d="m19.924093,9.272423l0,21.092876" fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="3"/>
                            <path stroke="#333" id="svg_3" d="m10.527747,21.255323l9.472253,9.472253l9.472253,-9.472253" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/>
                        </g>
                    </svg><span>Download het jaarverslag</span>
                </a>

            </div>
        </div>
    </nav>
</template>

<style lang="scss" scoped>
    // see /static/scss/components/_circles.scss
    .burger > *{
        // pointer-events:none;
    }
</style>

<script>
    import { Lethargy } from 'lethargy';

    let lethargy = new Lethargy( 7, 50, 0.05 );

    export default {
        props: {
            index: {
                type: Number,
                default: 0
            },
            items: {
                type: Array,
                default: () => []
            }
        },

        data()
        {
            return {
                open: false
            };
        },

        computed: {
            navItems()
            {
                let nav = [];
                for( let i in this.items )
                {
                    if( this.items[ i ].meta.slides )
                    {
                        nav.push({
                            index: parseInt( i, 10 ),
                            title: this.items[ i ].meta.title,
                            sub: this.items[ i ].meta.sub,
                            slides: this.items[ i ].meta.slides
                        });
                    }
                }
                return nav;
            },
            current()
            {
                for( let i in this.navItems )
                {
                    if( this.index >= this.navItems[i].index && this.index <= ( this.navItems[i].index + this.navItems[i].slides.length ) )
                    {
                        return this.navItems[i];
                    }
                }
                return null;
            }
        },

        methods: {
            onMouseOver( e )
            {
                if( window.innerWidth < 720 /* small */ )
                {
                    return;
                }

                this.open = true;
            },

            toggleOpen()
            {
                this.open = !this.open;
            },

            navigate( index, closeNav = false )
            {
                this.$store.dispatch( 'index', index );
                this.$emit( 'update' );
                this.open = !closeNav;
            },

            wheel( e )
            {
                let power = lethargy.check( e );
                if( power !== false )
                {
                    let nextIndex = this.navItems.indexOf( this.current ) + -power;
                    if( this.navItems[ nextIndex ] )
                    {
                        this.$store.dispatch( 'index', this.navItems[ nextIndex ].index );
                        this.$emit( 'update' );
                    }
                }
            }
        }
    };
</script>
